// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"395": "00f4d4a8ed0e5437","575": "899f79f43e6628dd","835": "eedce05d38edc8e6",}[chunkId] + ".css"
}